module.exports = __webpack_public_path__ + "static/media/galerija_2014 (21).f28471be.jpg";